import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router'
import { ElMessageBox } from "element-plus";
import Monitor from '../views/Monitor/Monitor.vue'
import Car_manage from '../views/Car_manage/Car_manage.vue'
import Four_cars from '../views/Car_manage/Four_cars'
import Bicycle_manage from '../views/Car_manage/Bicycle_manage'
import Op_manager from '../views/Op_manager/Op_manager.vue'
import Drive from '../views/Drive/Drive.vue'
import Home from '../views/Home/Home.vue'
import Login from '../views/Login/Login.vue'
import Car_monitoring from '../views/Car_monitoring/car_monitoring.vue'
import CarInfoTypeTwo from '../views/Car_monitoring/component/CarInfoTypeTwo.vue'
import Net_connection  from '../views/Net_connection/Net_connection.vue'
const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login
  },
  {
    path: '/Login',
    name: 'Login',
    component: Login
  },

  {
    path: '/Home',
    name: 'Home',
    component: Home,
    redirect: '/Monitor',
    children: [
      {
        path: '/Monitor',
        name: 'Monitor',
        component: Monitor
      },
      {
        path: '/Net_connection',
        name: 'Net_connection',
        component: Net_connection
      },    
      {
        path: '/Car_manage',
        name: 'Car_manage',
        component: Car_manage
      },
      {
        path: '/Op_manager',
        name: 'Op_manager',
        component: Op_manager
      },
      {
        path: '/Drive',
        name: 'Drive',
        component: Drive
      },
      {
        path: '/Four_cars',
        name: 'Four_cars',
        component: Four_cars
      },
      {
        path: '/Car_monitoring',
        name: 'Car_monitoring',
        component: Car_monitoring
      },
      {
        path: '/CarInfoTypeTwo',
        name: 'CarInfoTypeTwo',
        component: CarInfoTypeTwo
      },
      {
        path: '/Bicycle_manage',
        name: 'Bicycle_manage',
        component: Bicycle_manage
      }
    ]
  },

]
const router = createRouter({
  //两种路由模式
  history: createWebHashHistory(process.env.BASE_URL),
  // history: createWebHistory(process.env.BASE_URL),
  routes
})
router.beforeEach((to, from, next) => {
  if ( to.path === "/Login" ||  to.path === "/" ) {
    next();
  } else {
    let token = localStorage.getItem('qlzx_monitoring_api_token'); 
    if (token === null || token === '') {
      ElMessageBox.alert("请重新登录", "系统提示", {
        confirmButtonText: "OK",
        callback: (action) => {
          next('/Login');
        },
      })  
    } else {
      next();
    }
  }
});
export default router